// src/utils/rum.js - AWS CloudWatch RUM client initialisation
import { AwsRum } from 'aws-rum-web';

let rumClient = null;

export function initRum() {
  if (rumClient) return rumClient;

  try {
    const config = {
      sessionSampleRate: 1,
      identityPoolId: process.env.REACT_APP_RUM_IDENTITY_POOL_ID,
      endpoint: process.env.REACT_APP_RUM_ENDPOINT,
      telemetries: ['performance', 'errors', 'http'],
      allowCookies: true,
      enableXRay: true,
      signing: true,
    };

    rumClient = new AwsRum(
      process.env.REACT_APP_RUM_APP_ID,
      '1.0.0',
      process.env.REACT_APP_RUM_REGION,
      config
    );
  } catch (err) {
    // Never let RUM failure break the app
    console.warn('AWS RUM failed to initialise:', err);
  }

  return rumClient;
}

export const recordError = (error) => rumClient?.recordError(error);
export const recordEvent = (type, data) => rumClient?.recordEvent(type, data);
